import { RepoAnalyzerResponse } from '@/types/repoAnalyzer';
import { Star, Clock, Users, History } from 'lucide-react';

export const RepoInfo = ({ info, analysis, metrics }: RepoAnalyzerResponse) => {
  const metricsData = [
    { icon: Clock, label: 'Age', value: info.age },
    { icon: History, label: 'Last Update', value: info.lastUpdate.replace('ago', '') },
    { icon: Star, label: 'Stars', value: info.stars.toLocaleString() },
    { icon: Users, label: 'Contributors', value: metrics.contributors },
  ];

  return (
    <div className="w-full">
      <div className="flex justify-between items-start gap-6 flex-col sm:flex-row">
        <div className="flex-1 flex flex-row sm:flex-col gap-6">
          <div className="space-y-1">
            <div className="flex flex-row gap-3 items-center">
              <div
                className={`text-lg font-bold rounded-full w-[48px] h-[48px] flex items-center justify-center ${
                  analysis.score >= 80
                    ? 'bg-green-900/50 text-green-400'
                    : analysis.score >= 60
                      ? 'bg-yellow-900/50 text-yellow-400'
                      : 'bg-red-900/50 text-red-400'
                }`}
              >
                {analysis.score}
              </div>
              <span className="text-gray-300 text-lg">Analysis Score</span>
            </div>
            <h2 className="text-2xl font-bold text-gray-100">{info.name}</h2>
            <p className="text-gray-400">by {info.owner}</p>
            <p className="text-gray-300 text-sm max-w-md">{info.description}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-4 gap-y-4 w-full sm:w-72">
          {metricsData.map(({ icon: Icon, label, value }) => (
            <div
              key={label}
              className="flex items-center gap-3 border border-gray-800 px-4 py-2 rounded-lg"
            >
              <Icon className="w-4 h-4 text-gray-400 shrink-0" />
              <div className="min-w-0">
                <div className="text-gray-200 text-sm font-medium truncate">{value}</div>
                <div className="text-gray-400 text-xs">{label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
